import type { JSX, ReactNode } from 'react';

import { Box, Typography } from '@mui/material';
import styled from 'styled-components';

import { PAGE_ROUTES } from '../../utils/constants';

import './TitleSection.css';

const FormCompletionTime = styled.div`
  font: var(--sprout-font-body1);
  margin-top: 16px;
`;

function shouldShowTitle(
  isOnlyUtility: boolean | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formPages: any[] | undefined,
  scroll: boolean | undefined,
  currentPage: string | undefined
): boolean {
  if (currentPage === PAGE_ROUTES.faq) return true;

  const pageCount = formPages?.length ?? 0;
  if (isOnlyUtility) return false;

  return pageCount > 1 || !scroll;
}

interface TitleSectionProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  formCompletionTime?: ReactNode;
  isOnlyUtility?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formPages?: any[];
  scroll?: boolean;
  currentPage?: string;
  recordType?: string;
}

export default function TitleSection({
  title,
  subtitle,
  formCompletionTime,
  isOnlyUtility,
  formPages = [],
  scroll,
  currentPage,
  recordType
}: TitleSectionProps): JSX.Element | null {
  const showTitle = shouldShowTitle(
    isOnlyUtility,
    formPages,
    scroll,
    currentPage
  );

  if (!showTitle) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        width: '100%'
      }}
    >
      {currentPage !== PAGE_ROUTES.dashboard && (
        <Typography
          variant="h3"
          className="titleSectionTitle"
          sx={{
            fontSize: { xs: '32px', md: '40px' },
            lineHeight: { xs: '36px', md: '44px' },
            overflowWrap: 'anywhere',
            marginBottom:
              currentPage?.toLowerCase() !==
              PAGE_ROUTES.faqPage.toLowerCase()
                ? '8px'
                : 0,
            whiteSpace: 'normal',
            transition: '0.2s font-size ease-in'
          }}
        >
          {title || ''}
        </Typography>
      )}

      {subtitle && (
        <Typography
          component="h2"
          className="titleSectionSubtitle"
          sx={{
            overflow: 'hidden',
            whiteSpace: 'normal',
            textOverflow: 'ellipsis'
          }}
        >
          {subtitle}
        </Typography>
      )}

      {recordType === 'Customer Set Up' &&
        currentPage === PAGE_ROUTES.company && (
          <FormCompletionTime className="titleSectionSubtitle titleSectionSubtitleWithIcon">
            {formCompletionTime}
          </FormCompletionTime>
        )}
    </Box>
  );
}
